import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api";
import { UserDropdown } from "./UserDropdown";

function usePathname() {
  return typeof window !== "undefined" ? window.location.pathname : "";
}

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const { data } = useQuery({
    queryKey: ["admin", "me"],
    queryFn: () => apiFetch<{ user: { email?: string; display_name?: string } }>("/api/auth/me"),
  });

  const user = data?.user;
  const userName = user?.display_name?.trim() || user?.email?.split("@")[0] || "Admin";
  const userEmail = user?.email || "";

  function handleSettingsClick() {
    window.location.href = "/settings";
  }

  const isDashboard = pathname === "/" || pathname === "/dashboard";
  const isUsers = pathname === "/users";
  const isSubscriptions = pathname === "/subscriptions";

  return (
    <div className="admin-app">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="admin-sidebar-logo">
            <span className="material-symbols-outlined admin-sidebar-logo-icon">shield</span>
            <span className="admin-sidebar-logo-title">Admin</span>
          </div>
        </div>
        <nav className="admin-sidebar-nav">
          <a
            href="/"
            className={`admin-nav-item ${isDashboard ? "active" : ""}`}
          >
            <span className="material-symbols-outlined">dashboard</span>
            <span>Dashboard</span>
          </a>
          <a
            href="/users"
            className={`admin-nav-item ${isUsers ? "active" : ""}`}
          >
            <span className="material-symbols-outlined">group</span>
            <span>Users</span>
          </a>
          <a
            href="/subscriptions"
            className={`admin-nav-item ${isSubscriptions ? "active" : ""}`}
          >
            <span className="material-symbols-outlined">payments</span>
            <span>Subscriptions</span>
          </a>
        </nav>
        <div className="admin-sidebar-footer">
          <UserDropdown
            userName={userName}
            userEmail={userEmail}
            onSettingsClick={handleSettingsClick}
          />
        </div>
      </aside>
      <main className="admin-app-main">
        {children}
      </main>
    </div>
  );
}
